import { BaseTile } from "Components/BaseTile";
import { ProductBackendName } from "Features/CheckPrice/Products/productTypes";
import React, { useState } from "react";

import { CoopBenefits } from "Components/Partner/CoopBenefits/CoopBenefits";
import { AlternativeBankIdLogin } from "./AlternativeBankIdLogin";
import { AlternativeNoBankIdLogin } from "./AlternativeNoBankIdLogin";

interface Props {
  productBackendName: ProductBackendName;
}

/**
 Used for AB-testing the login flow in child insurance
 Can be used in any product if we are to scale up the testing.
*/

export const AlternativeProductLogin = ({
  productBackendName,
}: Props): React.ReactElement => {
  const [bankIdMode, setBankIdMode] = useState(true);

  return (
    <div aria-live="polite">
      <BaseTile>
        {bankIdMode ? (
          <AlternativeBankIdLogin setBankIdMode={setBankIdMode} />
        ) : (
          <AlternativeNoBankIdLogin productBackendName={productBackendName} />
        )}
        <CoopBenefits />
      </BaseTile>
    </div>
  );
};
